import { RollbackOutlined, StopOutlined } from '@ant-design/icons'
import { Card, Col, Row, Statistic } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

type Props = {
  pendingReturnsCount: number
  pendingCancellationsCount: number
  isLoading: boolean
}

const PENDING_CARDS = [
  {
    i18nKey: 'pendingReturns',
    countKey: 'pendingReturnsCount',
    path: '/returns?status=REQUESTED',
    icon: <RollbackOutlined />,
  },
  {
    i18nKey: 'pendingCancellations',
    countKey: 'pendingCancellationsCount',
    path: '/cancellations?status=REQUESTED',
    icon: <StopOutlined />,
  },
] as const

export function DashboardPendingItems({
  pendingReturnsCount,
  pendingCancellationsCount,
  isLoading,
}: Props): React.JSX.Element {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const counts = { pendingReturnsCount, pendingCancellationsCount }

  return (
    <Row gutter={[16, 16]}>
      {PENDING_CARDS.map(({ i18nKey, countKey, path, icon }) => (
        <Col key={countKey} xs={24} sm={12}>
          <Card
            data-testid={`dashboard-pending-card-${i18nKey.replace('pending', '').toLowerCase()}`}
            hoverable
            onClick={() => void navigate(path)}
          >
            <Statistic
              title={t(`pages.dashboard.${i18nKey}`)}
              value={counts[countKey]}
              prefix={icon}
              loading={isLoading}
              valueStyle={counts[countKey] > 0 ? { color: '#cf1322' } : undefined}
            />
          </Card>
        </Col>
      ))}
    </Row>
  )
}
